import {
  BinderDeliveryDto,
  useBinderDeliveryQuery
} from 'providers/api';
import React from 'react';
import { UseQueryResult } from 'react-query';
import { EditBinderDeliveryPageParams } from './constants';

export type EditBinderDeliveryQueries = [
  UseQueryResult<BinderDeliveryDto>
]

const useEditBinderDeliveryQueries = (params: EditBinderDeliveryPageParams): EditBinderDeliveryQueries => {
  const [binderDelivery, setBinderDelivery] = React.useState<BinderDeliveryDto | null>(null);

  const query = useBinderDeliveryQuery(
    params.binderDelivery,
    {
      enabled: !binderDelivery,
      cacheTime: 0,
    },
  );

  const { data, isFetched } = query;

  React.useEffect(() => {
    if (data && isFetched && !binderDelivery) {
      setBinderDelivery(data);
    }
  }, [data, binderDelivery, isFetched]);

  return [query];
};

export default useEditBinderDeliveryQueries;
